<template>
  <!--会议简介-->
  <div class="box clear" :style="{marginLeft: left}">
    <div class="box-contain left">
      <ul v-if="currentNavCon.comps && currentNavCon.comps.length>0">
        <li :class="{first: i===0}" v-if="currentNavCon.comps.length>0" v-for="(com,i) in currentNavCon.comps" :key="i" class="nav-con-item">
          <div v-if="com.cpnCode === 'def'">
            <!--def 会议简介等-->
            <div class="nav-title">
              <div>
                <span :style="{color: color}">{{com.cpnTitle}}</span>
              </div>
            </div>
            <div class="v-html"  v-html="com.cpnContent"
                 style="padding: 15px;word-break: break-all;overflow-x: auto;">
            </div>
          </div>
          <div v-if="com.cpnCode === 'info'">
            <div  :style="{color: color}" class="nav-title">
              <div>
                {{com.cpnTitle}}
              </div>
            </div>
            <consultation  style="padding: 12px;" :color="color" :data="com.cpnData"></consultation>
          </div>
          <!--<teacher v-if="com.cpnCode === 'vip'" :data="com"></teacher>-->
          <i-teacher v-if="com.cpnCode === 'vip'&&com.cpnData.length>0" :color="color" :info="currentNavCon" :dataInfo="com.cpnData" col="4" spanCol = "6"></i-teacher>

          <livecom :color="color" v-if="com.cpnCode === 'live'" :data="com" class="nav-con-item"></livecom>
          <daily v-if="com.cpnCode === 'cal'" :color="color" :data="com"></daily>
        </li>
      </ul>
      <ul v-if="currentNavCon && !currentNavCon.comps">
        <li class="nav-con-item" >
          <div v-if="currentNavCon.cpnCode === 'def'">
            <!--def 会议简介等-->
            <div class="nav-title">
              <div>
                <span :style="{color: color}">{{currentNavCon.cpnTitle}}</span>
              </div>
            </div>

              <div class="v-html" v-html="currentNavCon.cpnContent" style="word-break: break-all;height: 650px;overflow-y: auto;padding: 15px"></div>


          </div>
          <div v-if="currentNavCon.cpnCode === 'info'">
            <!--会议动态-->
            <div  :style="{color: color}" class="nav-title">
              <div>
                {{currentNavCon.cpnTitle}}
              </div>
            </div>
            <consultation style="padding: 12px;" :color="color" :data="currentNavCon.cpnData"></consultation>
          </div>
          <!--<teacher :color="color" v-if="currentNavCon.cpnCode === 'vip'" :data="currentNavCon"></teacher>-->
          <i-teacher v-if="currentNavCon.cpnCode === 'vip'&&currentNavCon.cpnData!=null" :color="color" :info="currentNavCon" :dataInfo="currentNavCon.cpnData" col="4" spanCol = "6"></i-teacher>
          <daily v-if="currentNavCon.cpnCode === 'cal'" :color="color" :data="currentNavCon"></daily>
          <div >
            <livecom  :color="color" v-if="currentNavCon.cpnCode === 'live'" :data="currentNavCon" class="nav-con-item"></livecom>
          </div>
        </li>
      </ul>
    </div>
    <!--显示更多区域-->
    <div class="box-contain left">
      <div style="background-color: #fff;" v-if="status==1">
        <div class="nav-title">
          <div>
            <span class="show-more back" @click="showMore">
              返回
            </span>
            <span>{{curObj.cpnTitle}}</span>
          </div>
        </div>
        <div  class="v-html" v-html="curObj.cpnContent"
             style="padding: 15px;word-break: break-all;height: 650px;overflow-y: auto;">
        </div>
      </div>
      <div style="background-color: #fff;" v-if="status==2">
        <div>
          <div class="nav-title">
            <div>
            <span class="show-more back" @click="showMore">
              返回
            </span>
              <span>
              {{curObj.cpnTitle}}
            </span>
            </div>
          </div>
        </div>
        <!--会议动态-->
        <ul class="dt">
          <li class="clear" v-for="(d,j) in curObj.cpnData" :key="j">
            <b :style="{backgroundColor:color}" class="tip"></b>
            <p class="left">{{d.infoTitle}}</p>
            <p class="right time">
              {{d.infoDt | date1}}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>
<script>
  import consultation from 'base/consultation'
  import teacher from '@/components/teacher/teacher'
  import daily from '@/components/daily/daily'
  import livecom from '@/components/livecom/livecom'
  import iTeacher from '@/components/iTeacher'
  export default{
    data(){
      return {
        showmore: false,
        left: 0,
        status: '',
        curObj:'',
      }
    },
    props: {
      currentNavCon: {},
      activeNav:{},
      color: {
          type: String,
        defualt: '#f39800'
      }
    },
    filters: {
      date1(str){
        let date = new Date(str).Format('yyyy.MM.dd');
        return date;
      }
    },
    methods: {
      // go(item){
      //   const url = location.origin + '#/view/' + this.$route.params.cid +"/"+ item.infoId
      //   window.open(url)
      // },
      showMore(curobj,status){
        this.showmore = !this.showmore;
        this.curObj = curobj;
        this.status = status;

        if (this.showmore) {
           this.left = '-808px'
        }else{
            this.left = '0'
        }
        let top = document.querySelector('#headerTop').offsetHeight;
        window.scrollTo(0,top)
      }
    },
    computed: {
      myData(){

      }
    },
    mounted(){
    },
    components:{
      consultation, teacher, daily, livecom, iTeacher
    }
  }
</script>
<style lang="scss" scoped>
  .box {
    width: 200%;
    transition: all ease-in .3s;
    .box-contain {
      width: 50%;
    }
  }

  .nav-con-item {
    margin-bottom: 10px;
    background-color: #ffffff;

  }

  .nav-title {
    display: table;
    width: 100%;
    line-height: 49px;
    border-bottom: 1px solid #EEEEEE;
    padding-right: 20px;
    padding-left: 15px;
    font-size: 16px;
    color: var(--color);
    & > div {
      display: table-cell;
    }
  }

  .right {
    float: right;
  }

  .left {
    float: left;
  }

  .dt {
    padding: 15px 0 19px 0;
  }

  .dt li {
    font-size: 14px;
    line-height: 25px;
    padding: 0 15px 0 30px;
    color: #333333;
    position: relative;
    b{
      display: inline-block;
      width: 6px;
      height: 6px;
      position: absolute;
      top: 50%;
      margin-top: -3px;
      left: 20px;
      border-radius: 50%;
    }
    .time {
      font-size: 12px;
    }
    :hover{
      color: #2342ff;
    }
  }

  .first {
    /*height: 324px;*/
    position: relative;
    /* 3 times the line-height to show 3 lines */
    /*overflow: hidden;*/
  }
  .show-more{
    cursor: pointer;
  }
  .back{
    float: right;
    font-size: 14px;
  }

  .overpoint{position: relative; max-height: 260px;overflow: hidden;}

  .point{position: relative; line-height: 25px; max-height: 250px;overflow: hidden;}
  .point::after{content: "..."; position: absolute; bottom: 0; right: 0; padding-left: 40px;
    background: -webkit-linear-gradient(left, transparent, #fff 55%);
    background: -o-linear-gradient(right, transparent, #fff 55%);
    background: -moz-linear-gradient(right, transparent, #fff 55%);
    background: linear-gradient(to right, transparent, #fff 55%);
  }
  .info{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// render-components.vue?826ce1f8